// Import SCSS
import '../scss/main.scss';

// Import dependencies
import 'bootstrap';
import 'datatables.net-bs4';
import InitiativeTable from "./modules/initiative-table";
import PlaceSearcher from "./modules/place-searcher";
import Editor from "./modules/editor";
import FilterTags from "./modules/filter-tags";
import FileUpload from "./modules/file-upload";
import InitiativeAddition from "./modules/initiative-addition";
import InitiativeBackend from "./modules/initiative-backend";
import User from "./modules/user";
import Backend from "./modules/backend";

// Load jquery-ui
import 'jquery-ui/ui/widgets/autocomplete';
import Map from "./modules/map";


// Load Datepicker
global.moment = require('moment');
require('tempusdominus-bootstrap-4');

let initiativeTable = new InitiativeTable;
let placeSearcher = new PlaceSearcher;
let editor = new Editor;
let filterTags = new FilterTags;
let fileUpload = new FileUpload;
let initiativeAddition = new InitiativeAddition;
let initiativeBackend = new InitiativeBackend();
let user = new User();
let backend = new Backend();

$(window).ready(function() {
    // Load modules
    initiativeTable.init();
    placeSearcher.init();
    editor.init();
    filterTags.init();
    fileUpload.init();
    initiativeAddition.init();
    initiativeBackend.init();
    user.init();
    backend.init();

    // Init tooltips and popovers globally
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    if ($("#map.map-simple").length) {
        this.map = new Map();
        this.map.init();
        this.map.initDefaultMapData();
    }
});


